(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/wager/assets/javascripts/cancel.js') >= 0) return;  svs.modules.push('/components/tur/wager/assets/javascripts/cancel.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

svs = svs || {};
(svs => {
  svs.tur.wager = _objectSpread(_objectSpread({}, svs.tur.wager), {}, {
    cancel(_ref) {
      let {
        wagerid,
        message,
        success,
        error,
        productId,
        wager,
        isSyndicate,
        numbersWagerData
      } = _ref;
      message = message || '<p>Vill du annullera spelet?</p>';

      if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        svs.components.account_balance.on('change', accountbalance => {
          this.balance = svs.utils.format.CurrencyFromJupiterString(accountbalance);
        });
        svs.components.customer_login.login();
      } else if (!isNaN(wagerid)) {
        if (isSyndicate) {
          message += '<p>En bekräftelse kommer att skickas till samtliga lagmedlemmar.</p>';
        }
        const confirmDialog = new svs.components.dialog.Confirm({
          branding: svs.components.dialog.branding.TUR,
          title: 'Annullera',
          message: [{
            type: svs.components.dialog.message.TEXT,
            text: message
          }],
          actions: [{
            type: svs.components.dialog.button.SECONDARY,
            title: 'Avbryt'
          }, {
            type: svs.components.dialog.button.SECONDARY,
            title: 'Annullera',
            callback: () => {
              this.cancelWager({
                wagerid,
                success,
                error,
                productId,
                wager,
                numbersWagerData
              });
              confirmDialog.close();
            }
          }]
        });
        svs.components.dialog.api.add(confirmDialog);
      }
    },
    cancelWager(_ref2) {
      let {
        wagerid,
        success,
        error,
        productId,
        wager,
        numbersWagerData
      } = _ref2;
      svs.events.publish('/loader/show');
      const cancelObject = {
        method: 'DELETE',
        path: "/wager/4/wagers/".concat(wagerid)
      };
      const trackingCancelWager = {
        wagerId: wagerid,
        totalPrice: 0,
        bets: []
      };
      svs.core.jupiter.call(cancelObject, data => {
        svs.tur.wager.logger.info("cancelwager success wagerid:".concat(wagerid, ", productId").concat(productId));
        if (numbersWagerData) {
          trackingCancelWager.bets = this.getNumbergamesTrackingCancelWager(numbersWagerData);
        } else if (wager) {
          switch (productId) {
            case 'LORLOTTO':
            case 'ONSLOTTO':
              {
                const jokerProduct = productId.replace('LOTTO', 'JOKER');
                let lottodata = _.where(wager.bets, {
                  productId
                });
                lottodata = lottodata[0];
                let jokerdata = _.where(wager.bets, {
                  productId: jokerProduct
                });
                jokerdata = jokerdata[0];
                const day = productId === 'LORLOTTO' ? 'Lördag' : 'Onsdag';
                const lotto1 = {
                  productName: "Lotto 1 ".concat(day),
                  productId: "".concat(productId, ".Annullering"),
                  price: svs.utils.format.CurrencyFromJupiterString(lottodata.betAmountSalesGroup1) * -1,
                  numberOfRows: 1
                };
                trackingCancelWager.bets.push(lotto1);
                if (lottodata.lottoBoards[0].participation === 'L1L2') {
                  const lotto2 = {
                    productName: "Lotto 2 ".concat(day),
                    productId: "".concat(productId, "2.Annullering"),
                    price: svs.utils.format.CurrencyFromJupiterString(lottodata.betAmountSalesGroup2) * -1,
                    numberOfRows: 1
                  };
                  trackingCancelWager.bets.push(lotto2);
                }
                if (wager.bets.length > 1) {
                  const lottojoker = {
                    productName: "Joker ".concat(day),
                    productId: "".concat(jokerProduct, ".Annullering"),
                    price: svs.utils.format.CurrencyFromJupiterString(jokerdata.betAmountSalesGroup1) * -1,
                    numberOfRows: 1
                  };
                  trackingCancelWager.bets.push(lottojoker);
                }
                break;
              }
            default:
              {
                let betdata = _.where(wager.bets, {
                  productId
                });
                betdata = betdata[0];
                const betinfo = {
                  productName: this.CONSTANTS.productName[productId],
                  productId: "".concat(productId, ".Annullering"),
                  price: svs.utils.format.CurrencyFromJupiterString(betdata.betAmountSalesGroup1) * -1,
                  numberOfRows: 1
                };
                trackingCancelWager.bets.push(betinfo);
              }
          }
        } else {
          let bet = {};
          if (productId) {
            bet = {
              productName: this.CONSTANTS.productName[productId],
              productId: "".concat(productId, ".Annullering"),
              price: svs.utils.format.CurrencyFromJupiterString(data.wagerAmounts.totalAmount) * -1,
              numberOfRows: 1
            };
          } else {
            bet = {
              productName: 'Okänd',
              productId: 'Okänd.Annullering',
              price: svs.utils.format.CurrencyFromJupiterString(data.wagerAmounts.totalAmount) * -1,
              numberOfRows: 1
            };
          }
          trackingCancelWager.bets.push(bet);
        }
        trackingCancelWager.totalPrice = svs.utils.format.CurrencyFromJupiterString(data.wagerAmounts.totalAmount) * -1;
        this.trackGA(trackingCancelWager);
        svs.events.publish('/loader/hide');
        svs.components.account_balance.get(true);
        svs.components.loader.hide();
        const title = 'Spel annullerat',
          message = "Ditt spel f\xF6r ".concat(svs.utils.format.Currency(data.wagerAmounts.betAmount), " kr har annullerats.");
        const dialog = new svs.components.dialog.Confirm({
          branding: svs.components.dialog.branding.TUR,
          title,
          message: [{
            type: svs.components.dialog.message.TEXT,
            text: message
          }],
          actions: [{
            type: svs.components.dialog.button.SECONDARY,
            title: 'Ok',
            callback: () => {
              dialog.close();
              success && success();
            }
          }]
        });
        svs.components.dialog.api.add(dialog);
      }, async (jqXHR, textStatus, errorThrown) => {
        var _response$error, _response$error2;
        svs.tur.wager.logger.warn("cancelwager failure (".concat(JSON.stringify(jqXHR), ", ").concat(textStatus, ", ").concat(errorThrown, ")"));
        const response = JSON.parse(jqXHR.responseText);
        svs.events.publish('/loader/hide');
        svs.components.loader.hide();

        const isPastCancelClose = parseInt(response === null || response === void 0 || (_response$error = response.error) === null || _response$error === void 0 || (_response$error = _response$error.code) === null || _response$error === void 0 ? void 0 : _response$error.replace(' ', ''), 10) === 8105;

        const noPermission = parseInt(response === null || response === void 0 || (_response$error2 = response.error) === null || _response$error2 === void 0 || (_response$error2 = _response$error2.code) === null || _response$error2 === void 0 ? void 0 : _response$error2.replace(' ', ''), 10) === 22125;
        let icon;
        let type;
        let title;
        let message;
        if (isPastCancelClose) {
          type = svs.ui.dialog.type.DEFAULT;
          icon = 'time-limit';
          title = 'Annullering inte möjlig';
          message = 'Du kan annullera ett spel upp till 5 minuter efter spelstopp. <br />Den tiden har tyvärr passerat.';
        } else if (noPermission) {
          type = svs.ui.dialog.type.ERROR;
          icon = 'error';
          title = "Du kan inte annullera spel i ".concat(wager.syndicateName);
          message = 'Lagledaren styr vem som kan lägga och annullera spel i laget.';
        } else {
          type = svs.ui.dialog.type.ERROR;
          icon = 'error';
          title = 'Fel';
          message = await svs.tur.apierrors.getErrorMessage(response);
          title = message.errorTitle || title;
          message = message.errorMessage || 'Tekniskt fel. Det gick tyvärr inte att annullera ditt spel.';
        }
        const errorDialog = new svs.components.dialog.Confirm({
          icon,
          type,
          branding: svs.components.dialog.branding.TUR,
          title,
          message: [{
            type: svs.components.dialog.message.TEXT,
            text: message,
            align: svs.ui.dialog.message.align.CENTER
          }],
          actions: [{
            type: svs.components.dialog.button.SECONDARY,
            title: 'Ok',
            callback: () => {
              errorDialog.close();
              error && error(response);
            }
          }]
        });
        svs.components.dialog.api.add(errorDialog);
      });
    },
    getNumbergamesTrackingCancelWager(_ref3) {
      let {
        productName,
        bet,
        hasLotto2,
        jokerBet
      } = _ref3;
      const bets = [],
        productDay = svs.numbergames.productMapping.getDay(productName),
        options = {
          productName,
          productId: svs.numbergames.productMapping.getProductItsId(productName),
          productDay,
          bet,
          numberOfRows: 1
        };
      bets.push(this.getNumbergamesTrackingCancelBet(options));
      if (hasLotto2) {
        bets.push(this.getNumbergamesTrackingCancelBet(_objectSpread(_objectSpread({}, options), {}, {
          partDrawNum: 2
        })));
      }
      if (jokerBet) {
        bets.push(this.getNumbergamesTrackingCancelBet({
          productName: 'Joker',
          productId: svs.numbergames.productMapping.getJokerProductId(productName),
          productDay,
          bet: jokerBet
        }));
      }
      return bets;
    },
    getNumbergamesTrackingCancelBet(_ref4) {
      let {
        productName,
        productId,
        productDay,
        bet,
        numberOfRows = 1,
        partDrawNum = 1
      } = _ref4;
      let price = parseInt(bet["betAmountSalesGroup".concat(partDrawNum)], 10);
      if (svs.numbergames.productMapping.isLotto(productId)) {
        productName = "Lotto ".concat(partDrawNum);
      }
      if (svs.numbergames.productMapping.isEurojackpot(productId)) {
        productName = 'Eurojackpot';
      }
      if (svs.numbergames.productMapping.isKeno(productId)) {
        price += parseInt(bet.betAmountSalesGroup2, 10);
      }
      if (productDay) {
        productName += " ".concat(productDay);
      }
      return {
        numberOfRows,
        price: "-".concat(price, ".00"),
        productId: "".concat(productId, ".Annullering"),
        productName
      };
    }
  });
})(svs);

 })(window);